
import { useParams } from "react-router-dom";

import { Box } from "@mui/material";
import { DisenioGranja } from "../../layout";
import { useGalponesXGranja } from "../../../hooks";
import { CargandoMedio, TablaListBodegas, TablaListGalpones } from "../../components";




export const GalponesXGranja = () => {


    const { id } = useParams();
    const { galponesXGranjaQuery } = useGalponesXGranja(id);

    
    

    return (

        <DisenioGranja titulo="Galpones de Granja" add={false}>
            {(galponesXGranjaQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Galpones..." />
            :   <TablaListGalpones data={galponesXGranjaQuery.data || []} />
            }

            <Box sx={{height:30}} />
        </DisenioGranja>

    )
}
